import { Component, Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControlExFactory } from '../../service/factory/form-control-ex-factory.service';
import { AutocompleteRemoteBase } from '../autocomplete-remote/autocomplete-remote.base';
import { AutoCompleteSelectionItem } from '../autocomplete-remote/autocomplete-selection-item';
import { IAutoCompleteService } from '../autocomplete-remote/autocomplete-service.interface';
import { ColumnDefinition } from '../../model/column-definition';
import { Subscription, fromEvent } from 'rxjs';

/* ...re-exports to simplify imports elsewhere. */
export { AutoCompleteSelectionItem, IAutoCompleteService };

@Directive()
export abstract class AutocompleteRemoteTableComponent<TData, TOptions>
  extends AutocompleteRemoteBase<TData, TOptions>
  implements OnInit, OnDestroy
{
  private _documentClickSubscription: Subscription;

  constructor(fcf: FormControlExFactory) {
    super(fcf, true);
    this.closePopup();
  }

  popupOpen: boolean;
  columnDefinition: ColumnDefinition[];

  @ViewChild('autocompleteInput') autocompleteInput: ElementRef;
  @ViewChild('autocompletePopup') autocompletePopup: ElementRef;
  @Output() itemSelectedNewId = new EventEmitter<AutoCompleteSelectionItem>();

  ngOnInit(): void {
    super.ngOnInit();

    const documentClick$ = fromEvent<MouseEvent>(document, 'click');
    const hideRepresentativesFilterBound = this._hideRepresentativesFilter.bind(this);
    this._documentClickSubscription = documentClick$.subscribe(hideRepresentativesFilterBound);
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this._documentClickSubscription.unsubscribe();
  }

  protected setControlValue(item: AutoCompleteSelectionItem<TData>) {
    super.setControlValue(item);
    this.itemSelectedNewId.emit(item); // (note: this can be null)
  }

  getSourceItemsData(): TData[] {
    return this.itemsSource?.map(x => x.data) ?? [];
  }

  openPopup() {
    this.popupOpen = true;
  }

  closePopup() {
    this.popupOpen = false;
  }

  // OnBlur simulation
  private _hideRepresentativesFilter(event: MouseEvent) {
    if (this.autocompletePopup) {
      const isInsideTooltip = this.isDescendant(this.autocompletePopup.nativeElement, event.target);
      if (
        event.target !== this.autocompleteInput.nativeElement &&
        event.target !== this.autocompletePopup.nativeElement &&
        !isInsideTooltip
      ) {
        this.closePopup();
      }
    }
  }

  private isDescendant(parent, child) {
    let node = child;
    while (node !== null) {
      if (node === parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }
}
